import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '@services/app.service';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { UserService } from '@services/user.service';
import { WebErrorService } from '@services/webError.service';
import { UserUnblockedComponent } from './user-unblocked/user-unblocked.component';
import { Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { videoAssetGroups } from '@configs/videoTitles';
import { AccountAdminRole } from '@configs/role.config';
import { counterTime } from '@configs/questions.config';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  lockedData: any;
  changePwdForm: FormGroup;
  languageData = [];
  browserLang: string;
  selectedLang;
  dummyOption;
  displayedColumns: string[] = [ 'userName','email','lockoutDate','status','temporaryPassStatus','action'];
  displayedColumns1: string[] = [ 'ExamineeName','email','lockoutDate','status','temporaryPassStatus','action'];
  lockedUsersForm: FormGroup;
  User: boolean = true;
  noUsers: boolean = false;
  noExaminees: boolean = false
  rowStates: { [key: string]: boolean } = {};

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
      this.lockedData.paginator = paginator;
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  temppasswordstatus: any;
  action: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  accountAdmin = AccountAdminRole.accountAdmin;
  userData: any;
  countDown: Subscription;
  counter = counterTime.counter;
  isEnable: boolean = false;
  enableTimer: boolean = false;
  minutes: number;
  timeLeft: Date = new Date(this.counter * 1000); // Convert to Date object for formatting
  private intervalId: any;
  private startTime: number = 0;
  isTimeShow: boolean = false;
  seconds: any;
  constructor(private userService: UserService,
    private router: Router,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private location: Location,
    private appService: AppService,
    public dialog: MatDialog,
    public roleSer: RoleManagementService) {

    }

  ngOnInit(): void {
    this.startTimer()
    this.userData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.changePwdForm = new FormGroup({
      oldPassword: new FormControl('',
        [Validators.required]),
      newPassword: new FormControl('',
        [Validators.required,
        Validators.minLength(12),
        Validators.maxLength(20),
        // Validators.pattern(/^(?!.*(.)\1)(?!.*?123|321|234|432|345|543|456|654|567|765|678|876|789|987|890|098)(?=.{12,}).*$/),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$'),
        this.validatePassword
        ]),
      confirmPassword: new FormControl('',
        [Validators.required,
        Validators.minLength(12),
        Validators.maxLength(20),
        // Validators.pattern(/^(?!.*(.)\1)(?!.*?123|321|234|432|345|543|456|654|567|765|678|876|789|987|890|098)(?=.{12,}).*$/),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$'),
        this.validatePassword
        ]),
        otp: new FormControl('', [Validators.required])
    })
    this.setOtpValidator();

    // Set langId here to set default dropdown value
    const langId = localStorage.getItem("langId");
    if(langId != undefined || null || '') {
      this.selectedLang = langId;
    }

    this.userService.getLanguage().subscribe(data => {
      this.languageData = data.items;
    });
  //  this.load()

    this.loadUserLocked();
    this.translate.stream('headerNav.profile.option3.action').pipe(takeUntil(this.unsubscribe)).subscribe(translation => { this.action = translation });
    this.translate.stream('headerNav.profile.option3.temppasswordstatus').pipe(takeUntil(this.unsubscribe)).subscribe(translation => { this.temppasswordstatus = translation });
  }


  setOtpValidator(): void {
    const otpControl = this.changePwdForm.get('otp');
    if (this.userData.isTwoFactorAuthentication) {
      otpControl?.setValidators([Validators.required]);
    } else {
      otpControl?.clearValidators();
    }
    otpControl?.updateValueAndValidity();
  }

  startTimer() {
    this.startTime = Date.now();
    this.intervalId = setInterval(() => {
      const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
      const remaining = this.counter - elapsed;

      if (remaining <= 0) {
        this.isEnable = false;
        this.enableTimer = false;
        clearInterval(this.intervalId);
        this.timeLeft = new Date(0); // Reset to 0
      } else {
        this.isTimeShow = true;
        this.timeLeft = new Date(remaining * 1000);
        this.minutes = Math.floor(remaining / 60);
        this.seconds = this.timeLeft.getSeconds();
      }
    }, 1000);
  }

  onTraningIcon(assetGroup) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.userService.videoTutorial(assetGroup).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  load(event: MatRadioChange){
      if (event.value == 'user') {
        this.User = true
        this.loadUserLocked();
      }
      else if (event.value == "examinee") {
        this.User = false;
        this.loadExamineeLocked();

      }
  }

  loadExamineeLocked() {
    this.noExaminees = true;
    this.noUsers = false;
    this.userService.lockedExamineeList()
    .subscribe(
      (resData) => {
        this.lockedData = resData.data;
        if(!this.lockedData.length) {
          this.noExaminees = true;
          this.noUsers = false;
        } else {
          this.noExaminees = false;
          this.noUsers = false;
          this.lockedData = new MatTableDataSource(this.lockedData);
          setTimeout(()=>{
            this.lockedData.sort = this.sort;
            this.lockedData.paginator = this.paginator;
            this.setExamineePaginator();
          })
        }
      },(error)=>{
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
  }

  loadUserLocked() {
    this.noUsers = true;
    this.noExaminees = false;
    this.userService.lockedUserList()
        .subscribe(
          (resData) => {
            this.lockedData = resData.data;
            if(!this.lockedData.length) {
              this.noUsers = true;
              this.noExaminees = false;
            } else {
              this.noExaminees = false;
              this.noUsers = false;
              this.lockedData = new MatTableDataSource(this.lockedData);
              setTimeout(()=>{
                this.lockedData.sort = this.sort;
                this.lockedData.paginator = this.paginator;
                this.setUserPaginator();
              })
            }
          },(error)=>{
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
  }

  setUserPaginator(): void {
    this.lockedData.paginator = this.paginator;
    this.lockedData.sort = this.sort;

    // ------Set translation for pagination------
    if(this.lockedData.paginator) {
      this.translate.stream([
        'headerNav.profile.option3.UserPagination.pageLabel',
        'headerNav.profile.option3.UserPagination.firstPage',
        'headerNav.profile.option3.UserPagination.lastPage',
        'headerNav.profile.option3.UserPagination.nextPage',
        'headerNav.profile.option3.UserPagination.prevPage'
      ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
          this.lockedData.paginator._intl.itemsPerPageLabel = translation['headerNav.profile.option3.UserPagination.pageLabel'];
          this.lockedData.paginator._intl.firstPageLabel = translation['headerNav.profile.option3.UserPagination.firstPage'];
          this.lockedData.paginator._intl.lastPageLabel = translation['headerNav.profile.option3.UserPagination.lastPage'];
          this.lockedData.paginator._intl.nextPageLabel = translation['headerNav.profile.option3.UserPagination.nextPage'];
          this.lockedData.paginator._intl.previousPageLabel = translation['headerNav.profile.option3.UserPagination.prevPage'];

          this.lockedData.paginator._intl.changes.next();
      });
    }
  }

  setExamineePaginator(): void {
    this.lockedData.paginator = this.paginator;
    this.lockedData.sort = this.sort;

    // ------Set translation for pagination------
    if(this.lockedData.paginator) {
      this.translate.stream([
        'headerNav.profile.option3.ExamineePagination.pageLabel',
        'headerNav.profile.option3.ExamineePagination.firstPage',
        'headerNav.profile.option3.ExamineePagination.lastPage',
        'headerNav.profile.option3.ExamineePagination.nextPage',
        'headerNav.profile.option3.ExamineePagination.prevPage'
      ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
          this.lockedData.paginator._intl.itemsPerPageLabel = translation['headerNav.profile.option3.ExamineePagination.pageLabel'];
          this.lockedData.paginator._intl.firstPageLabel = translation['headerNav.profile.option3.ExamineePagination.firstPage'];
          this.lockedData.paginator._intl.lastPageLabel = translation['headerNav.profile.option3.ExamineePagination.lastPage'];
          this.lockedData.paginator._intl.nextPageLabel = translation['headerNav.profile.option3.ExamineePagination.nextPage'];
          this.lockedData.paginator._intl.previousPageLabel = translation['headerNav.profile.option3.ExamineePagination.prevPage'];

          this.lockedData.paginator._intl.changes.next();
      });
    }
  }

  unlockUser(row: any) {
    this.userService.unlockUser(row.useruuid).subscribe(
      (ResData)=>{
        this.unlockedMessagePopUp(ResData);
        this.rowStates[row.useruuid] = true;
        this.lockedData = new MatTableDataSource(this.lockedData);
        this.loadUserLocked();
      },(error)=>{
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      }
    )
  }

  unlockExaminee(row: any) {
    this.userService.unlockExaminee(row.examineeUuid).subscribe(
      (ResData)=>{
        this.unlockedMessagePopUp(ResData);
        this.rowStates[row.examineeid] = true;
        this.lockedData = new MatTableDataSource(this.lockedData);
        this.loadExamineeLocked();
      },(error)=>{
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      }
    )
  }

  validatePassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.value;
    const regData = JSON.parse(sessionStorage.getItem('currentUser'))
    if (password.includes(regData.emailId)){
      return { passwordSameAsUsernameOrEmail: true };
    }
    return null;
  }
  switchLang(event: any) {
    const apiData = {
      langaugeId: event.target.value
    };
    this.userService.updateUserSetting(apiData).subscribe(res=>{
      const langId = event.target.value
      localStorage.setItem('langId',langId);
      const langCode = event.target.options[event.target.selectedIndex].dataset.label;
      localStorage.setItem("language", langCode);
      this.translate.use(langCode);
      if (this.User) {
        this.loadUserLocked();
      } else {
        this.loadExamineeLocked();
      }
    })
  }

  get f() {
    return this.changePwdForm.controls;
  }

  arePasswordsValid(): boolean {
    return this.f.oldPassword.valid && this.f.newPassword.valid && this.f.confirmPassword.valid;
  }

  submit() {
    const apiData = {
      // collectioId: this.collectionId,
      oldPassword: this.changePwdForm.value.oldPassword,
      newPassword: this.changePwdForm.value.newPassword,
      confirmPassword: this.changePwdForm.value.confirmPassword,

    }


    this.userService.changePwd(apiData).subscribe(resData => {
      this.notificationService.success(resData?.message);
      //  this.location.back();  //It Goes back to last page that user have visited
      if (resData.useruuid) {
        // this.router.navigate(["/users", data.testId]);

      }
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error, null, true, 'warn');
    });
  }
  cancel() {
    this.location.back();  //It Goes back to last page that user have visited
  }

  unlockedMessagePopUp(ResData) {
    const dialogSubscription = this.dialog.open(UserUnblockedComponent, { data: {Message: ResData.message}, minWidth: '600px'}).afterClosed().subscribe(result => {
      dialogSubscription.unsubscribe();
    });
  }

  countDownFun() {
    this.countDown = timer(0, 1000).subscribe(() => {
      --this.counter
      if (this.counter === 0) {
        this.isEnable = false;
        this.enableTimer = false;
        this.countDown.unsubscribe();
      }
    });
  }

  sendAuthenticationCode() {
    this.userService.authenticationCode(this.userData.emailId).subscribe(res=>{
      if(res.status != 'true'){

      } else {
        // this.isCodeReceived = false;
        this.isEnable = true;
        this.enableTimer = true;
        this.counter = counterTime.counter;
        this.startTimer()
      }
    })
  }

}
